import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";

import { Box } from "@mui/joy";
import { Container, Grid, Link, Typography } from "@mui/material";
import SideBar from "../../components/Setting/Sidebar";

const MyProfile = () => {
  return (
    <>
      <Box className="home-bg pt-8 pb-20">
        <Box className="container-xxl">
          <Box className="d-flex flex-wrap justify-content-between align-items-center gap-4">
            <Box>
              <Link className="small text-white opacity-75" href="/">
                <ArrowBackIosIcon className="small-icon" /> Back Home
              </Link>
              <Typography className="text-white my-1" variant="h5">
                Account Overview
              </Typography>
            </Box>
            <Box className="d-flex gap-3">
              <Link className="btn btn-light" href="/login?cmd=logout">
                <ExitToAppIcon className="text-icon" /> Sign Out
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>

      <Container className="container-xxl pb-16 mt-n14">
        <Grid container spacing={2}>
          <Grid item xl={3} lg={4}>
            <SideBar />
          </Grid>
          <Grid item xl={9} lg={8}>
            <Box className="card mb-4">
              <Box className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Public Profile Info</h3>
              </Box>
              <Box className="card-body">
                <p>
                  Your Public Profile information is{" "}
                  <strong>shared publicly</strong>. Please{" "}
                  <strong>DO NOT</strong> enter sensitive information such as
                  your private keys here.
                </p>
                <Box className="row align-items-baseline">
                  <Box className="col-md-4 text-muted mb-1 mb-md-0">
                    <BrokenImageOutlinedIcon className="text-icon me-0.5" />
                    Public Profile Picture
                  </Box>
                  <Box className="col-md-8">
                    <span id="avatar">
                      <img
                        id="icon"
                        className="rounded-circle me-3"
                        width="40"
                        height="40"
                        alt=""
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAA5JJREFUeF7t3cFNHFEQRdGeJCyxsFg7CqdAGoTtlSUHAQincJCePn3ZF1W8uv9VdU9P83j99fZ+wc/fH88QXagq8PTvD/2KRwCQfvPgAJi3YFtAAGz1n2cPgHkLtgUEwFb/efYAmLdgW0AAbPWfZw+AeQu2BQTAVv959gCYt2BbQABs9Z9nD4B5C7YFBMBW/3n2AJi3YFtAAGz1n2efAzBXoAJIAX4egLIXPFcgAOYt2BYQAFv959kDYN6CbQEBsNV/nj0A5i3YFhAAW/3n2QNg3oJtAQGw1X+ePQDmLdgWEABb/efZA2Degm0BAbDVf549AOYt2BYQAFv959kZAH0/gD7QoPm1A+v6NX8AIAHaAAVY8wdAAGxfEaME6wnC/l/r+jV/DoAEaAMUYM0fAAHQCBAG9ATmAPiaMxVQmv8ZGwD4nsC1gAEwflFkANiLNlW/lkC0AG2AjjDNHwAB0FWAMKAnMAfoKkD446uQRgDJ32XgtbYwzY/95xOo9esIYgdQATVeBdT82gDNr/EBgAoGAAqo4TmAKZgDmH68A2B6Dg8AlLARgAJqeCPAFMwBTL9GAOrH4TmASZgDmH45AOrH4TmASZgDmH45AOrH4TmASZgDmH45AOrH4TmASZgDmH45AOrH4TmASTh3AG3g+l786fUHgB2g+RNRWP4VAKhgDnBzAQMgAEiB9Q7TCKD2Xe0AqN/xAjYCkIDTBTy9/kbAzQEOgACwbwejfu0A+OVY1T8HQAXbAW4uYAAEACnQjaDxW8aoe1c3glS/lsD1Evjy++c7dxF+gVqgzmAo/X/o6fU/AsAQCADT7/gTFAABQAqsR1gjgNrXDoDynS9gIwAROF3A0+tvBNwc4AAIgG4ECQONAFHvG9xJC4AAIAW6D4AfhqwFzAGI/+4DrAHuKuDmAAfA3QF4Hf/bONSfP03U/GsL1x2Enwo+XYAAyAGIgdMPQA5A7feHQjE9j8AAwA7kAPhYN+rPJ0DzB0AAKEMU31UA3kom9b/giyGaPwACgBhqCST5ugrgr3ah/i2B6IA5ABLYVUBXAYiQhbcEogWa/O0A7QCHO2A7AFpAOwCeAJ1h2L95uAKk+s0dQP+AeQexgAAYL3HYPw4PgAAgiNRBGwEkvwfnADkAUZQDkHz74BwgByAKcwCSbx+cA+QARGEOQPLtg3OAHIAozAFIvn1wDpADEIU5AMm3D84BcgCiUB3gA0huqe5i80gSAAAAAElFTkSuQmCC"
                      />
                    </span>
                    <Link
                      href="#"
                      id="ContentPlaceHolder1_addnew"
                      data-bs-toggle="modal"
                      rel="tooltip"
                      data-bs-target="#myModal"
                      className="btn btn-white ms-1"
                    >
                      <span>Change picture</span>
                    </Link>
                  </Box>
                </Box>
                <hr />
                <Box className="row align-items-baseline">
                  <Box className="col-md-4 text-muted mb-1 mb-md-0">
                    <ContactMailOutlinedIcon className="text-icon me-0.5" />
                    UPCX Explorer Public Profile
                  </Box>
                  <Box className="col-md-8">
                    <Link
                      href="/public-profile?uid=5ed1aca1"
                      className="btn btn-secondary"
                      target="_blank"
                    >
                      View Public Profile page{" "}
                      <ArrowOutwardOutlinedIcon className="text-icon ms-1" />
                    </Link>
                  </Box>
                </Box>
                <hr />
                <Box className="row align-items-baseline">
                  <Box className="col-md-4 text-muted mb-1 mb-md-0">
                    <BadgeOutlinedIcon className="text-icon me-0.5" />
                    Public Profile Name
                  </Box>
                  <Box className="col-md-8">
                    <input
                      name="ctl00$ContentPlaceHolder1$txtPskljnjk2rofime"
                      type="text"
                      placeholder="Public user profile name"
                      className="form-control py-2"
                    />
                  </Box>
                </Box>
                <hr />
                <Box className="row align-items-baseline">
                  <Box className="col-md-4 text-muted mb-1 mb-md-0">
                    <LanguageOutlinedIcon className="text-icon me-1" />
                    Public Profile Website
                  </Box>
                  <Box className="col-md-8">
                    <input
                      name="ctl00$ContentPlaceHolder1$txtProfileWebsite"
                      id="ContentPlaceHolder1_txtProfileWebsite"
                      type="text"
                      placeholder="https://yourwebsite.com"
                      className="form-control py-2"
                    />
                  </Box>
                </Box>
                <hr />
                <Box className="row">
                  <Box className="col-md-4 text-muted mb-1 mb-md-0">
                    <BiotechOutlinedIcon className="text-icon me-0.5" />
                    Public Profile Bio
                  </Box>
                  <Box className="col-md-8">
                    <textarea
                      name="ctl00$ContentPlaceHolder1$txtProfileBio"
                      rows={2}
                      cols={20}
                      placeholder="Your Public Profile bio info (up to 155 characters)"
                      className="form-control"
                    ></textarea>
                  </Box>
                </Box>
              </Box>

              <Box className="card-footer bg-light d-md-flex justify-content-end gap-2">
                <Link className="btn btn-ghost-white" href="/mysettings">
                  Cancel
                </Link>
                <input
                  type="submit"
                  name="ctl00$ContentPlaceHolder1$btnSave"
                  value="Save Changes"
                  id="ContentPlaceHolder1_btnSave"
                  className="btn btn-primary"
                  style={{ display: "none" }}
                />
                <input
                  type="button"
                  className="btn btn-primary"
                  value="Save Changes"
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MyProfile;
